<div class="abnormal_state" [ngStyle]="{background: background}" >
  <loader-pane-fragment [trace]="traceName"></loader-pane-fragment>
  <div *ngIf="data.imageClass" class="image" [ngClass]="data.imageClass"></div>
  <h1 *ngIf="title || data.title">{{ title ? title : data.title }}</h1>
  <div class="description" *ngIf="data.message" [innerHTML]="publicHelpers.strWithBreak(data.message)" ></div>
  <div class="description" *ngIf="data.postMessage" [innerHTML]="publicHelpers.strWithBreak(data.postMessage)" ></div>
  <button *ngIf="!!data.buttonText && !hideButton" matButton="filled" color="primary" (click)="buttonClick.emit()">{{ data.buttonText }}</button>
</div>